var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArj(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e0"
    },
    d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d9d7ca"
    },
    points: "37.5,0.151 37.5,12 49.349,12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95a5a5",
      fillOpacity: 1
    },
    d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "M28.5,24v-2h2v-2h-2v-2h2v-2h-2v-2h2v-2h-2v-2h2V8h-2V6h-2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2 h-4v5c0,2.757,2.243,5,5,5s5-2.243,5-5v-5H28.5z M30.5,29c0,1.654-1.346,3-3,3s-3-1.346-3-3v-3h6V29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "M26.5,30h2c0.552,0,1-0.447,1-1s-0.448-1-1-1h-2c-0.552,0-1,0.447-1,1S25.948,30,26.5,30z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.99029518,1.0097999)",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "13.88474941px",
      fontFamily: "Allerta",
      InkscapeFontSpecification: "Allerta",
      fill: "#fff",
      fillOpacity: 0.94117647
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 15.840497,52.525024 3.498306,-9.979663 1.61356,0 3.471187,9.979663 -1.681356,0 -0.718645,-2.074576 -3.755933,0 -0.732203,2.074576 -1.694916,0 z m 2.80678,-3.172882 2.983052,0 -1.477966,-4.311865 -1.505086,4.311865 z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 31.569314,52.525024 -1.884746,-3.62034 q -0.04068,0 -0.108475,0.01356 -0.0678,0 -0.216949,0 -0.135593,0 -0.433898,0 -0.284746,0 -0.786441,0 l 0,3.60678 -1.627119,0 0,-9.993223 2.874577,0 q 0.637288,0 1.261017,0.20339 0.623729,0.20339 1.111865,0.61017 0.501695,0.40678 0.8,0.989831 0.311865,0.569491 0.311865,1.288136 0,1.084746 -0.501695,1.844068 -0.501696,0.759322 -1.355933,1.125424 l 2.277967,3.932204 -1.722035,0 z m -3.430509,-4.800001 1.477966,0 q 0.298306,0 0.596611,-0.09492 0.298305,-0.108475 0.542373,-0.338983 0.244068,-0.230509 0.39322,-0.637289 0.149153,-0.420339 0.149153,-1.030508 0,-0.244068 -0.0678,-0.555933 -0.0678,-0.325423 -0.284746,-0.610169 -0.20339,-0.298305 -0.583051,-0.488136 -0.379661,-0.20339 -1.00339,-0.20339 l -1.220339,0 0,3.959323 z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 40.7083,42.328412 0,7.783052 q 0,0.705085 -0.257627,1.193221 -0.257628,0.474577 -0.691526,0.772882 -0.433898,0.284746 -1.00339,0.406779 -0.555933,0.108475 -1.152543,0.108475 -0.298305,0 -0.705085,-0.0678 -0.39322,-0.05424 -0.827119,-0.176271 -0.420339,-0.135593 -0.813559,-0.298305 -0.393221,-0.162712 -0.664407,-0.366102 l 0.691525,-1.098305 q 0.135594,0.09492 0.379662,0.20339 0.257627,0.09492 0.555932,0.18983 0.298305,0.08136 0.623729,0.149153 0.325424,0.0678 0.61017,0.0678 0.718644,0 1.138983,-0.271187 0.433898,-0.284746 0.461017,-0.949153 l 0,-7.647459 1.654238,0 z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArj);
export default __webpack_public_path__ + "static/media/arj.35529a2b7875416f727186bf0162466f.svg";
export { ForwardRef as ReactComponent };